<template>
<div class="container pt-3" >
  <!-- กล่่องข้อความเตือนต่ออายุสมาชิก -->
  <div class="alert alert-danger" v-if="corpID>0 & globalCorpInfo.LeftDays<31 & globalCorpInfo.LeftDays>0">
    <strong>เตือนต่ออายุสมาชิก</strong>
    <div class="row g-0">
      <div class="col-md-1">
        <img src="../assets/date_expired.png" class="img-fluid rounded-start" style="width:60px" alt="...">
      </div>
      <div class="col-sm text-start">
          <p>ใกล้ถึงวันครบอายุสมาชิกในวันที่ <span class="text-danger"> {{globalCorpInfo.PackageDateEnd}}</span>
          <span style="font-size:150%;"> ({{globalCorpInfo.LeftDays}} days) </span>
           คุณสามารถต่อสมาชิกได้ก่อนครบกำหนดเพื่อการใช้งานที่ต่อเนื่อง</p>
          <p class="small text-end text-secondary"> (ข้อความแจ้งเตือนอัตโนมัติ)</p>
      </div>
    </div>
  </div>
  <!-- กล่่องข้อความหมดอายุสมาชิก -->
  <div class="container d-flex justify-content-center text-center" v-if="corpID>0 & globalCorpInfo.LeftDays<1">
    <div class="card shadow mb-3" style="width: 540px;">
      <h6 class="card-title bg-warning text-dark p-2">ครบอายุสมาชิก</h6>
      <div class="row g-0">
        <div class="col-md-4">
          <img src="../assets/stop.png" class="img-fluid rounded-start pt-2" style="width:80px" alt="...">
        </div>
        <div class="col-sm bg-light">
          <div class="card-body">
            <p>หมดอายุสมาชิกตั้งแต่วันที่ <span class="text-danger"> {{globalCorpInfo.PackageDateEnd}}</span> </p>
            <hr>
            <p class="small"> คุณสามารถต่อสมาชิก เพื่อเข้าใช้งานอีกครั้ง</p>
            <br>
            <p class="small text-secondary"> (ข้อความแจ้งเตือนอัตโนมัติ)</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- กล่่อง Logon : Clinic -->
  <div class="row " v-if="corpID<=0" style=" margin-top:120px;">
    <div class="col-sm d-flex justify-content-center text-center">
      <div class="card shadow mb-3" style="max-width: 580px;">
        <div class="row g-0">
          <div class="col-md-4" style="background-color:CornflowerBlue">
            <img src="../assets/logo.png" class="img-fluid rounded-start pt-2" alt="...">
          </div>
          <!-- CARD : Corp Logon -->
          <div class="col-sm bg-light">
            <div class="card-body">
              <h5 class=""><b><span class="text-white bg-primary ps-1 py-1">LAB</span><span class="text-warning bg-primary py-1 pe-1">SMART</span></b></h5><h6> โปรแกรมแล็บเทคนิคการแพทย์</h6>
              <p class="card-text text-info"><b>{{userName}}</b> </p>
              <p class="card-text"><small class="text-muted">- ป้อนรหัส <b>คลินิก</b>  เพื่อเข้าใช้งาน -</small></p>
              <div >
                <div class="input-group input-group-sm">
                  <span class="input-group-text" style="width:160px;">รหัสคลินิก :</span>
                  <input type="text" class="form-control form-control-sm" ref="logon_corpname" name="logon_corpname" v-model="logon_corpname">
                </div>
                <div class="input-group input-group-sm">
                  <span class="input-group-text " style="width:160px;">รหัสผ่าน :</span>
                  <input type="password" class="form-control form-control-sm" name="logon_corppassword"
                    @keyup.enter="checkCorpPwdOK_Post()"
                    v-model="logon_corppassword">
                </div>
                <br>
                <button type="button" class="btn btn-primary btn-sm" v-if="corpID<=0" @click="checkCorpPwdOK_Post()">สมาชิกเข้าใช้งาน</button>
                <button type="button" class="btn btn-secondary btn-sm mx-2" @click="resetFormLogonClinic()">Reset</button>
              </div>
              <button type="button" class="btn btn-danger btn-sm" v-if="corpID>0" @click="corpLogoff()">Log off | ออกจากระบบ</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- กล่่อง Logon : ผู้ใช้งานในแต่ละคลินิก -->
  <div class="row" v-if="corpID>0 & globalCorpInfo.LeftDays>0">
    <div class="col-sm  d-flex justify-content-center text-center">
      <div class="card shadow-lg mb-3" style="max-width: 600px; margin-top:180px; background-color:Navy;">
        <div class="row g-0">
          <div class="col-md-5 bg-info d-flex justify-content-center align-items-center p-4" style="background-color:white;">
            <!-- Div แสดงข้อมูลคลินิก อาทิ ชื่อ แพคเกจ จำนวนวันคงเหลือ -->
            <div class="row">
              <img src="../assets/doctor.png" class="rounded-start" alt="Man" width="100" style="vertical-align:middle;">
              <p class="card-text" style="font-size:12px;">แพคเกจ : <b>Standard</b> <br> ใช้งานได้ถึงวันที่ : {{globalCorpInfo.PackageDateEnd}} <br> <span style="font-size:140%;"><b>({{globalCorpInfo.LeftDays}} days)</b></span></p>
              <span style="font-size:12px;">สามาชิก : <h6 class="card-title text-white">{{ globalCorpInfo.name }}</h6></span>
            </div>
          </div>
          <!-- CARD : User Logon -->
          <div class="col-md-7" style="background-color:white;">
            <div class="card-body">
              <img src="../assets/logo.png" class="img-fluid rounded-start" alt="Man" width="80" style="vertical-align:middle;">
              <div class="card-title">
                <h5 class=""><b><span class="text-white bg-primary ps-1 py-1">LAB</span><span class="text-warning bg-primary py-1 pe-1">SMART</span></b></h5><h6> โปรแกรมแล็บเทคนิคการแพทย์</h6>
              </div>
              <div v-if="userID<=0">
                <p class="card-text"><small class="text-muted">- ป้อนรหัสผู้ใช้งานและรหัสผ่าน -</small></p>
                <div class="input-group input-group-sm">
                  <span class="input-group-text" style="width:160px;">รหัสประจำตัวผู้ใช้งาน :</span>
                  <input type="text" class="form-control form-control-sm" ref="logon_username" name="logon_username" v-model="logon_username">
                </div>
                <div class="input-group input-group-sm">
                  <span class="input-group-text " style="width:160px;">รหัสผ่าน :</span>
                  <input type="password" class="form-control form-control-sm" name="logon_password"
                    @keyup.enter="checkUserPwdOK_Post()"
                    v-model="logon_password">
                </div>
                <p class="mt-3 fs-6">Password อักษรตัวเล็กตัวใหญ่มีค่าต่างกัน</p>
                <br>
                <div class="row">
                  <div>
                    <button type="button" class="btn btn-primary float-sm-end btn-sm" v-if="this.userID<=0" @click="checkUserPwdOK_Post()">Log on | เข้าระบบ</button>
                    <button type="button" class="btn btn-secondary btn-sm float-sm-end mx-2" @click="resetFormLogon()">Reset</button>
                    <button type="button" class="btn btn-danger float-sm-start btn-sm me-5" v-if="this.corpID>0" @click="corpLogoff()" title="ออกจากระบบ"> ปิดคลินิก</button>
                  </div>
                </div>
              </div>

              <p class="card-text text-primary"><b>{{userOfficialName}}</b> </p>
              <button type="button" class="btn btn-danger btn-sm" v-if="userID>0" @click="userLogoff()">Log off | ออกจากระบบ</button>
              <!-- <router-link class="btn btn-primary btn-sm" to="/Login" v-if="this.UserID==0">Log on | เข้าระบบ</router-link> -->
              <!-- <button type="button" class="btn btn-primary btn-sm" v-if="this.UserID==0">Log on | เข้าระบบ</button> -->
              <!-- <button type="button" class="btn btn-danger btn-sm" v-if="this.UserID>0">Log off | ออกจากระบบ</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { inject, ref } from 'vue'

export default {
  setup () {
    var counter = inject('counter', ref(-1))
    var corpID = inject('corpID', ref(-1))
    var corpName = inject('corpName', ref(''))
    var branchID = inject('branchID', ref(-1))
    var userID = inject('userID', ref(-1))
    var userName = inject('userName', ref(''))
    var userOfficialName = inject('userOfficialName', ref(''))
    var userPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      counter,
      corpID,
      corpName,
      branchID,
      userID,
      userName,
      userOfficialName,
      userPosition,
      globalCorpInfo,
      inc () {
        counter.value++
        userID.value = 5
        userName.value = 'TOM Login'
      },
      corpLogoff () {
        corpID.value = 0
        corpName.value = ''
      },
      userLogoff () {
        userID.value = 0
        userName.value = ''
        userOfficialName.value = ''
      }
    }
  },
  name: 'Home',
  data () {
    return {
      logon_corpname: '',
      logon_corppassword: '',
      logon_username: '',
      logon_password: '',
      // รายชื่อ พนง ในระบบ
      dataOfficerlists: [],
      // รายชื่อสาขาทั้งหมด
      dataBranchlists: []
    }
  },
  components: {

  },
  mounted () {
    this.getOfficerData()
    this.getBranchData()
  },
  methods: {
    resetFormLogonClinic () {
      this.logon_corpname = ''
      this.logon_corppassword = ''
      this.$refs.logon_corpname.focus()
    },
    resetFormLogon () {
      this.logon_username = ''
      this.logon_password = ''
      this.$refs.logon_username.focus()
    },
    checkCorpPwdOK () {
      // this.userID = 1
      var self = this
      // MyApiClient.post('getdata/logincheck_user_post.php', { U1: self.logon_username, P1: self.logon_password })
      MyApiClient.get('getdata/logincheck_corp.php?U1=' + self.logon_corpname + '&P1=' + self.logon_corppassword)
        .then((resp) => {
          // console.log(resp)
          if (resp.data.status) {
            self.corpID = resp.data.CorpID
            self.corpName = resp.data.CorpName

            self.globalCorpInfo.name = resp.data.Name
            self.globalCorpInfo.name2 = resp.data.Name2
            self.globalCorpInfo.addr1 = resp.data.Addr1
            self.globalCorpInfo.addr2 = resp.data.Addr2
            self.globalCorpInfo.tambol = resp.data.Tambol
            self.globalCorpInfo.amphor = resp.data.Amphor
            self.globalCorpInfo.province = resp.data.Province
            self.globalCorpInfo.zipcode = resp.data.Zipcode
            self.globalCorpInfo.tel1 = resp.data.Tel1
            self.globalCorpInfo.tel2 = resp.data.Tel2
            self.globalCorpInfo.fax = resp.data.Fax
            self.globalCorpInfo.email1 = resp.data.Email1
            self.globalCorpInfo.email2 = resp.data.Email2
            self.globalCorpInfo.logoFile = resp.data.logoFile
            // ล้างหน้าจอ
            this.logon_corpname = ''
            this.logon_corppassword = ''
          } else {
            // console.log(resp)
            console.log('Error1 ' + resp.statusText)
          }
        })
        .catch((err) => {
          console.log(err.data)
        })
    },
    checkCorpPwdOK_Post () {
      var self = this
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'getdata/logincheck_corp_post.php',
        data: { Corpname: self.logon_corpname, Password: self.logon_corppassword },
        statusCode: {
          200: function () {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'เปิดคลินิกแล็บ..' + self.logon_corpname,
              showConfirmButton: false,
              timer: 2000
            }).then((result) => {
              self.$router.push('/Home')
            })
          },
          204: function () {
            Swal.fire({ icon: 'error', text: 'ตรวจสอบรหัสผ่านปัจจุบัน..แล้วดำเนินการอีกครั้ง' })
          },
          404: function () {
            alert('server page not found')
          }
        },
        success: function (data, status, xhr) {
          if (status === 'success') {
            var corpInfo = JSON.parse(data)
            // console.log('AFTER LOGON Success..')
            // console.log(corpInfo.MemberName)
            self.corpID = corpInfo.CorpID
            self.corpName = corpInfo.CorpName

            self.globalCorpInfo.MemberName = corpInfo.MemberName
            self.globalCorpInfo.taxid = corpInfo.TaxID
            self.globalCorpInfo.name = corpInfo.Name
            self.globalCorpInfo.name2 = corpInfo.Name2
            self.globalCorpInfo.addr1 = corpInfo.Addr1
            self.globalCorpInfo.addr2 = corpInfo.Addr2
            self.globalCorpInfo.tambol = corpInfo.Tambol
            self.globalCorpInfo.amphor = corpInfo.Amphor
            self.globalCorpInfo.province = corpInfo.Province
            self.globalCorpInfo.zipcode = corpInfo.Zipcode
            self.globalCorpInfo.tel1 = corpInfo.Tel1
            self.globalCorpInfo.tel2 = corpInfo.Tel2
            self.globalCorpInfo.fax = corpInfo.Fax
            self.globalCorpInfo.email1 = corpInfo.Email1
            self.globalCorpInfo.email2 = corpInfo.Email2

            self.globalCorpInfo.InvcTaxID = corpInfo.InvcTaxID
            self.globalCorpInfo.InvcName = corpInfo.InvcName
            self.globalCorpInfo.InvcName2 = corpInfo.InvcName2
            self.globalCorpInfo.InvcAddr1 = corpInfo.InvcAddr1
            self.globalCorpInfo.InvcAddr2 = corpInfo.InvcAddr2
            self.globalCorpInfo.InvcTambol = corpInfo.InvcTambol
            self.globalCorpInfo.InvcAmphor = corpInfo.InvcAmphor
            self.globalCorpInfo.InvcProvince = corpInfo.InvcProvince
            self.globalCorpInfo.InvcZipcode = corpInfo.InvcZipcode
            self.globalCorpInfo.InvcTel1 = corpInfo.InvcTel1
            self.globalCorpInfo.InvcTel2 = corpInfo.InvcTel2
            self.globalCorpInfo.InvcFax = corpInfo.InvcFax
            self.globalCorpInfo.InvcEmail1 = corpInfo.InvcEmail1
            self.globalCorpInfo.InvcEmail2 = corpInfo.InvcEmail2

            self.globalCorpInfo.logoFile = corpInfo.logoFile
            self.globalCorpInfo.PackageType = corpInfo.PackageType
            self.globalCorpInfo.PackageDateBegin = corpInfo.PackageDateBegin
            self.globalCorpInfo.PackageDateEnd = corpInfo.PackageDateEnd
            self.globalCorpInfo.DateIN = corpInfo.DateIN
            self.globalCorpInfo.LeftDays = corpInfo.LeftDays
            self.globalCorpInfo.StatusStep = corpInfo.StatusStep
            self.globalCorpInfo.eGFR_ID = corpInfo.eGFR_ID
            self.globalCorpInfo.Cr_ID = corpInfo.Cr_ID
            // A/G Ratio : (Albumin/Globulin Ratio)
            self.globalCorpInfo.AGRatio_ID = corpInfo.AGRatio_ID
            self.globalCorpInfo.Albumin_ID = corpInfo.Albumin_ID
            self.globalCorpInfo.Globulin_ID = corpInfo.Globulin_ID
            self.globalCorpInfo.TotalProtein_ID = corpInfo.TotalProtein_ID

            self.globalCorpInfo.TC_ID = corpInfo.TC_ID
            self.globalCorpInfo.HDL_ID = corpInfo.HDL_ID
            self.globalCorpInfo.LDL_ID = corpInfo.LDL_ID
            self.globalCorpInfo.TG_ID = corpInfo.TG_ID
            // eAG : Estimated average glucose
            self.globalCorpInfo.eAG_ID = corpInfo.eAG_ID
            self.globalCorpInfo.HbA1C_ID = corpInfo.HbA1C_ID
            // Differential WBC Count 100%
            self.globalCorpInfo.Neutrophil_ID = corpInfo.Neutrophil_ID
            self.globalCorpInfo.Eosinophil_ID = corpInfo.Eosinophil_ID
            self.globalCorpInfo.Basophil_ID = corpInfo.Basophil_ID
            self.globalCorpInfo.Lymphocyte_ID = corpInfo.Lymphocyte_ID
            self.globalCorpInfo.Monocyte_ID = corpInfo.Monocyte_ID
            self.globalCorpInfo.AtypicalLymp_ID = corpInfo.AtypicalLymp_ID

            // ล้างหน้าจอ
            this.logon_corpname = ''
            this.logon_corppassword = ''
          }
          // console.log('AFTER LOGON')
          // console.log(JSON.parse(data))
          // console.log(status)
        }
      }).done(function () {
        self.resetFormLogonClinic()
      })
    },
    checkUserPwdOK () {
      // this.userID = 1
      var self = this
      // MyApiClient.post('getdata/logincheck_user_post.php', { U1: self.logon_username, P1: self.logon_password })
      MyApiClient.get('getdata/logincheck_user.php?C1=' + self.corpID + '&U1=' + self.logon_username + '&P1=' + self.logon_password)
        .then((resp) => {
        // result => Array of Record
          // console.log('AFTER LOGON')
          // console.log(resp)
          // console.log(resp.data.Username)
          // console.log(resp.data.UserID)
          // console.log(resp.data.OfficialName)
          if (resp.data.status) {
            self.userID = resp.data.UserID
            self.userName = resp.data.Username
            self.userOfficialName = resp.data.OfficialName
            self.userPosition = resp.data.Position
            self.branchID = resp.data.BranchID
            // ล้างหน้าจอ
            this.logon_username = ''
            this.logon_password = ''
          } else {
            console.log('Error2 ' + resp.statusText)
            // console.log(resp)
          }
        })
        .catch((err) => {
          console.log('catch error..')
          console.log(err.data)
        })
    },
    checkUserPwdOK_Post () {
      var self = this
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'getdata/logincheck_user_post.php',
        data: { CorpID: self.corpID, Username: self.logon_username, Password: self.logon_password },
        statusCode: {
          200: function () {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'ยินดีต้อนรับ..' + self.logon_username,
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.$router.push('/Home')
            })
          },
          204: function () {
            Swal.fire({ icon: 'error', text: 'ตรวจสอบรหัสผ่านปัจจุบัน..แล้วดำเนินการอีกครั้ง' })
          },
          404: function () {
            alert('server page not found')
          }
        },
        success: function (data, status, xhr) {
          if (status === 'success') {
            var userInfo = JSON.parse(data)
            self.userID = userInfo.UserID
            self.userName = userInfo.Username
            self.userOfficialName = userInfo.OfficialName
            self.userPosition = userInfo.Position
            self.branchID = userInfo.BranchID
            // ล้างหน้าจอ
            this.logon_username = ''
            this.logon_password = ''
          }
          // console.log('AFTER LOGON')
          // console.log(JSON.parse(data))
          // console.log(status)
        }
      }).done(function () {
        self.resetFormLogon()
      })
    },
    printBr () {
      var pos = this.dataOfficerlists.map(function (e) { return e.UserID }).indexOf(this.userIDLogin)
      console.log(this.dataOfficerlists[pos].OfficialName)
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php')
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php')
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>
